import { render, staticRenderFns } from "./deptLazyTree.vue?vue&type=template&id=65c8a2ae&scoped=true&"
import script from "./deptLazyTree.vue?vue&type=script&lang=js&"
export * from "./deptLazyTree.vue?vue&type=script&lang=js&"
import style0 from "./deptLazyTree.vue?vue&type=style&index=0&id=65c8a2ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8a2ae",
  null
  
)

export default component.exports